export enum Block$Type {
	syndicate = 'TCClassLib.API.Blocks.Syndicate, TCClassLib',
	folder = 'TCClassLib.API.Folder, TCClassLib',
	link = 'TCClassLib.API.Blocks.Link, TCClassLib',
	report = 'TCClassLib.API.Blocks.Report, TCClassLib',
	task = 'TCClassLib.API.Blocks.Task, TCClassLib',
	comment = 'TCClassLib.API.Blocks.Comment, TCClassLib',
}

export enum BlockData$Type {
	title = 'TCClassLib.API.TitleData, TCClassLib',
	syndicateSubcatCounter = 'TCClassLib.API.SyndicateSubcatCounterBlockData, TCClassLib',
	syndicateCat = 'TCClassLib.API.SyndicateCatBlockData, TCClassLib',
	url = 'TCClassLib.API.UrlData, TCClassLib',
}

export enum ActionType {
	syndicate = 'Syndicate',
	link = 'Link',
	task = 'Task',
	report = 'Report',
	comment = 'Comment',
}

export interface IBlockData {
	tasks: any[];
	fullTasks?: any;
	id: number;
	type: string;
	title: string;
	url?: string;
	counter?: number;
	allCounter?: number;
	overdueCounter?: number;
	templateInfo?: any;
	templates: any[];
	taskId?: number;
}

export interface ITemplate {
	id: string;
	title?: string;
	align?: any;
}

export interface IBlock {
	data?: IBlockData;
	action: ActionType;
	type: string;
	id: string;
	template: ITemplate;
	blocks?: IBlock[];
}

export interface IMobileContainer {
	blocks: IBlock[];
	id: string;
	template: ITemplate;
}

export interface IMobileContainerResultDto {
	data: IMobileContainer[];
	total: number;
	aggregates?: any;
}
